// export const pageConfig = () =>{
//     return {
//         pfyxUrl:""
//     }
// }
export const baseUrl = process.env.VUE_APP_BASE_API
export const baseProtocolUrl = process.env.VUE_APP_BASE_PROTOCOL

/**
 * 防抖函数，返回函数连续调用时，空闲时间必须大于或等于 wait，func 才会执行
 *
 * @param  {function} fn          回调函数
 * @param  {number}   delay       表示时间窗口的间隔
 * @param  {boolean}  immediate   设置为ture时，是否立即调用函数
 * @return {function}             返回客户调用函数
 */
export function debounce(fn, delay = 500, immediate = true) {
    var timeout,
        args,
        context,
        timestamp,
        result
    var later = function () {
        var last = Date.now() - timestamp

        if (last < delay && last >= 0) {
            timeout = setTimeout(later, delay - last)
        } else {
            timeout = null
            if (!immediate) {
                result = fn.apply(context, args)

                if (!timeout) {
                    context = args = null
                }
            }
        }
    }

    return function () {
        context = this
        args = arguments
        timestamp = Date.now()
        console.log(timestamp)
        var callNow = immediate && !timeout
        if (!timeout) {
            timeout = setTimeout(later, delay)
        }
        if (callNow) {
            result = fn.apply(context, args)
            context = args = null
        }
        return result
    }
}
/**
 *节流函数，固定时间间隔执行函数
 *
 * @export
 * @param {function} method         回调函数
 * @param {number} duration         时间间隔
 * @param {number} delay            延迟时间
 * @returns
 */
export function throttle(method, duration, delay) {
    var timer = null
    // 记录下开始执行函数的时间
    var begin = new Date()

    return function () {
        var context = this
        var args = arguments
        // 记录下当前时间
        var current = new Date()
        // 函数节流里的思路
        clearTimeout(timer)

        // 记录下的两个时间相减再与duration进行比较
        if (current - begin >= duration) {
            method.apply(context, args)
            begin = current
        } else {
            timer = setTimeout(function () {
                method.apply(context, args)
            }, delay)
        }
    }
}

// export const debounce = function (func, wait, immediate){
//     // debugger
//         console.log('防抖开始');
//     console.log(func)
//     console.log(wait)
//     console.log(immediate)
//                             var timeout;
//                             return function(){
//                                 var context = this,
//                                     args = arguments;
//                                 var later = function(){
//                                     timeout = null;
//                                     if(!immediate) func.apply(context, args);
//                                 };
//                                 var callNow = immediate && !timeout;
//                                 clearTimeout(timeout);
//                                 timeout = setTimeout(later, wait);
//                                 if(callNow) func.apply(context, args);
//                             }
//                         }

// // 这个是用来获取当前时间戳的
// function now() {
//     return +new Date()
// }
// /**
//  * 防抖函数，返回函数连续调用时，空闲时间必须大于或等于 wait，func 才会执行
//  *
//  * @param  {function} func        回调函数
//  * @param  {number}   wait        表示时间窗口的间隔
//  * @param  {boolean}  immediate   设置为ture时，是否立即调用函数
//  * @return {function}             返回客户调用函数
//  */

// export const debounce = function (func, wait = 500, immediate = true) {
//     // debugger
//     console.log('防抖开始');
//     console.log(func)
//     console.log(wait)
//     console.log(immediate)
//     let timer, context, args

//     // 延迟执行函数
//     const later = () => setTimeout(() => {
//         // 延迟函数执行完毕，清空缓存的定时器序号
//         timer = null
//         // 延迟执行的情况下，函数会在延迟函数中执行
//         // 使用到之前缓存的参数和上下文
//         if (!immediate) {
//             func.apply(context, args)
//             context = args = null
//         }
//     }, wait)

//     // 这里返回的函数是每次实际调用的函数
//     return function (...params) {
//         // 如果没有创建延迟执行函数（later），就创建一个
//         if (!timer) {
//             timer = later()
//             // 如果是立即执行，调用函数
//             // 否则缓存参数和调用上下文
//             if (immediate) {
//                 func.apply(this, params)
//                 func()
//             } else {
//                 context = this
//                 args = params
//             }
//             // 如果已有延迟执行函数（later），调用的时候清除原来的并重新设定一个
//             // 这样做延迟函数会重新计时
//         } else {
//             clearTimeout(timer)
//             timer = later()
//         }
//     }
// }